// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"257":"54a07034","326":"6f1f7f84"}[chunkId] + ".chunk.css";
};